import { toast } from 'react-toastify';

const customToast = (msg) => {
  toast(msg, {
    hideProgressBar: true
  });
};

export default customToast;